import apiClient from '../utils/apiClient';

/**
 * Message Template Service
 * Handles all message template related API calls
 */
const messageTemplateService = {
  /**
   * Get all message templates with optional filtering
   * @param {Object} filters - Optional filters (channel, search)
   * @param {string} filters.channel - Filter by channel (email, whatsapp, sms)
   * @param {string} filters.search - Search query
   * @returns {Promise<Object>} Response with templates data
   */
  getAll: async (filters = {}) => {
    try {
      // Build query string
      const queryParams = new URLSearchParams();
      if (filters.channel) {
        queryParams.append('channel', filters.channel);
      }
      if (filters.search) {
        queryParams.append('search', filters.search);
      }

      const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';

      const response = await apiClient.get(`/message-templates${queryString}`);
      
      if (response.success && response.data) {
        return {
          success: true,
          data: response.data
        };
      }

      return {
        success: false,
        error: response.message || 'Failed to fetch message templates.'
      };
    } catch (error) {
      console.error('Error fetching message templates:', error);
      return {
        success: false,
        error: error.message || 'Failed to fetch message templates.'
      };
    }
  },

  /**
   * Get a single message template by ID
   * @param {string} id - Template ID
   * @returns {Promise<Object>} Response with template data
   */
  getById: async (id) => {
    try {
      const response = await apiClient.get(`/message-templates/${id}`);
      
      if (response.success && response.data) {
        return {
          success: true,
          data: response.data
        };
      }

      return {
        success: false,
        error: response.message || 'Failed to fetch message template.'
      };
    } catch (error) {
      console.error('Error fetching message template:', error);
      return {
        success: false,
        error: error.message || 'Failed to fetch message template.'
      };
    }
  }
};

export default messageTemplateService;


